import App, { Container } from 'next/app';
import React from 'react';
import getConfig from 'next/config';
import { Provider } from 'react-redux';
import withRedux from 'next-redux-wrapper';
import axios from 'axios';
import get from 'lodash/get';
import { setMobileDetect, mobileParser } from 'react-responsive-redux';
import * as Sentry from '@sentry/browser';
import SentryBoundary from '../components_common/SentryBoundary/SentryBoundary';
import configureStore from '../store/configureStore';
import timerQueue from '../helpers/TimerQueue';
import { getClientInfo } from '../helpers/tracking';
import { setCountryCode } from '../modules/manageCountryCode';

class MyApp extends App {
  constructor(props) {
    super(props);
    const dsn = process.env.SENTRY_DSN_CONSUMER || null;
    const { publicRuntimeConfig } = getConfig();
    if (dsn && PRODUCTION) {
      Sentry.init({
        dsn,
        environment: 'production',
        release: publicRuntimeConfig.gitHash,
        attachStacktrace: true
      });
    }
  }

  componentDidMount() {
    timerQueue.init();
    setTimeout(() => axios.post('/api/store_client_info', getClientInfo()), 0);
  }

  static async getInitialProps({ Component, ctx }) {
    const { req, store } = ctx;
    if (!req) {
      return { pageProps: {} };
    }

    req.datadog.increment('consumer_app.app_js');

    const mobileDetect = mobileParser(req);
    const { dispatch } = store;
    const countryCode = get(req, 'backend_status.countryCode', '');
    await dispatch(setCountryCode(countryCode));
    await dispatch(setMobileDetect(mobileDetect));

    let pageProps = Component.getInitialProps ? await Component.getInitialProps(ctx) : {};
    return { pageProps };
  }

  render() {
    const { Component, pageProps, store } = this.props;

    return (
      <Container>
        <Provider store={store}>
          <SentryBoundary>
            <Component {...pageProps} />
          </SentryBoundary>
        </Provider>
      </Container>
    );
  }
}

export default withRedux(configureStore)(MyApp);
